import { forwardRef } from 'react';
import Select, { Theme } from 'react-select';
import { StateManagerProps } from 'react-select/dist/declarations/src/useStateManager';
import InputError from '../Error';
import Label from '../Label';
import Creatable from 'react-select/creatable';

import './ReactSelect.css';
export interface ReactSelectProps extends Omit<StateManagerProps, 'styles'> {
  error?: string;
  label?: string;
  isCreatable?: boolean;
}

const ReactSelect = forwardRef<any, ReactSelectProps>(
  ({ error, label, ...rest }, ref) => {
    const { id, isCreatable } = rest;
    const labelView = label && <Label htmlFor={id}>{label}</Label>;
    const errorView = error && <InputError>{error}</InputError>;
    const customizations = {
      classNamePrefix: 'react-select',
      className: 'custom-container',
      menuPortalTarget: document.body,
      styles: { menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) },
      theme: (theme: Theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#10B981',
          primary25: '#F3F4F6',
        },
      }),
    };
    if (isCreatable) {
      return (
        <>
          {labelView}
          <Creatable
            {...rest}
            ref={ref}
            {...customizations}
            isValidNewOption={() => true}
          />
          {errorView}
        </>
      );
    }
    return (
      <>
        {labelView}
        <Select {...rest} ref={ref} {...customizations} />
        {errorView}
      </>
    );
  }
);

export default ReactSelect;
